import makeRequest from "../utils/makeRequest";
import * as urls from "../utils/URLConst";
import toastNotify from "../utils/ToastNotify";

export const getCaptchaCode = async () => {
    try {
        const payload = {};
        const config = {};

        const result = await makeRequest("POST", urls.GetCaptcha, payload, config)
        if (result.STATUS === '0') {
            return result.RESPONSE[0];
        } else {
            result.MESSAGE !== "No data found" && toastNotify(result.MESSAGE, 'error');
            return null;
        }
    } catch (error) {
        console.log("error", error);
    }
};

// Created Ticket For Inquiries
export async function generateInquiryTicket(val) {
    try {
        // setIsLoadingSave(true);

        const payload = {
            DEPARTMENT_CD: "1",
            PRODUCT_CD: val.ITEM_CD,
            SUBJECT: val.subject,
            DESCRIPTION: val.discription,
            FILE_B64: "",
            FILE_SIZE: "",
            PRIORITY: "N",
            CLASSIFICATION: "Q",
        };

        const config = {};
        await makeRequest("POST", urls.setTicket, payload, config).then(
            (result) => {
                if (result.STATUS === "0") {
                    toastNotify(`Ticket Created ${result.MESSAGE}`, "success");
                    return true;
                } else {
                    toastNotify(result.MESSAGE, "error");
                    return false;
                }
            }
        );
    } catch (error) {
        console.error("Error fetching data:", error);
        return false;
    }
}